import { Component, Input } from '@angular/core';
import { Case } from '@app/shared/models/case';
import { UpdateComponent } from '@app/shared/components/base/update.component';

@Component({
  selector: 'quick-processing-switches',
  templateUrl: './quick-processing-switches.component.html',
  styleUrls: ['./quick-processing-switches.component.scss']
})
export class QuickProcessingSwitchesComponent extends UpdateComponent {

  @Input()
  public case: Case;

}
